module.exports = __webpack_public_path__ + "img/f4.648ef827.png";